import LinkBase from './LinkBase.jsx';

export default function MegaMenuColumnItem({ isOpen, isMobile, ...props }) {
  function calculateTabIndex() {
    if (isMobile && !isOpen) {
      return '-1';
    }
    return '0';
  }
  return (
    <li
      tabIndex="-1"
      className="lds-header-menu-item lds-header-menu-item-type-link"
    >

      <div className="lds-header-menu-item-content">
        <div className="lds-header-menu-item-text">
          <LinkBase {...props} tabIndex={calculateTabIndex()} />
        </div>
      </div>
    </li>
  );
}
